import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { sectionMargins } from '../styles';

const StyledFullWidthImage = styled.section`
  ${({ isBlogSingle }) =>
    isBlogSingle ? sectionMargins('30px', '50px') : sectionMargins()}
`;

const FullWidthImage = ({ image: { gatsbyImageData, alt }, isBlogSingle }) => (
  <StyledFullWidthImage isBlogSingle={isBlogSingle}>
    <GatsbyImage image={gatsbyImageData} alt={alt} />
  </StyledFullWidthImage>
);

export default FullWidthImage;
